import { Link } from "react-router-dom";
import ArticleCard from "@/components/feature/ArticleCard";
import type { Article } from "@/types/content";
import { formatViews } from "@/utils/content";

export default function LatestSection({ list, hot }: { list: Article[]; hot: Article[] }) {
  return (
    <section className="border-b border-background-200 bg-background-50">
      <div className="w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_320px]">
          <div>
            <div className="flex items-center justify-between">
              <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">最新整理</h2>
              <Link to="/topics" className="whitespace-nowrap text-sm text-primary-600 transition-colors hover:text-primary-700 cursor-pointer">
                更多内容
              </Link>
            </div>
            <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-3">
              {list.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </div>

          <aside className="lg:sticky lg:top-24 lg:self-start">
            <div className="rounded-lg border border-background-200 bg-background-100 p-5">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <i className="ri-fire-line text-lg text-primary-500"></i>
                热议排行
              </h3>
              <p className="mt-1.5 text-xs text-foreground-500">按近 7 天阅读量统计</p>
              <ol className="mt-4 flex flex-col">
                {hot.map((article, index) => (
                  <li key={article.id} className="border-b border-background-200 py-3 last:border-b-0">
                    <Link to={`/article/${article.id}`} className="group flex items-start gap-3 cursor-pointer">
                      <span
                        className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                          index < 3
                            ? "bg-primary-500 text-background-50"
                            : "bg-background-200 text-foreground-600"
                        }`}
                      >
                        {index + 1}
                      </span>
                      <div className="min-w-0">
                        <p className="line-clamp-2 text-sm font-medium leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
                          {article.title}
                        </p>
                        <p className="mt-1 flex items-center gap-1 text-xs text-foreground-500">
                          <i className="ri-eye-line"></i>
                          {formatViews(article.views)}
                        </p>
                      </div>
                    </Link>
                  </li>
                ))}
              </ol>
            </div>

            <div className="mt-5 rounded-lg border border-accent-300 bg-accent-50 p-5">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-accent-950">
                <i className="ri-lightbulb-line text-lg text-accent-700"></i>
                阅读提示
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-accent-900">
                每篇整理都标注了公开来源与整理时间。看到新的说法时，先对照时间线，再判断它是新增证据还是重复转述。
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}